import { TrustpilotWidgetComponent } from './../../../../../../git_modules/@tomandco/dragonfly-module-trustpilot/src/trustpilot-widget.component';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { UiComponent } from '@df/ui/ui.component';

export namespace NCmsTrustpilotWidget {
    export const ID = 'trustpilot-widget';
    export interface IData extends NICmsContentComponent.IData {
        hideTrustpilot?: boolean;
        templateId: string;
        businessunitId: string;
        styleHeight?: string;
        styleWidth?: string;
        theme?: string;
        stars?: string;
        reviewLanguages?: string;
    }
    export const getFields = (
        omit: (
            | 'trustpilotLabel'
            | 'hideTrustpilot'
            | 'templateId'
            | 'businessunitId'
            | 'styleHeight'
            | 'styleWidth'
            | 'theme'
            | 'stars'
            | 'reviewLanguages'
        )[],
        canShow?: (data: any, outletOptions: NICmsContentComponent.IOutletOptions) => boolean
    ) =>
        [
            {
                key: 'trustpilotLabel',
                title: 'Trustpilot',
                type: NICmsContentField.EFieldType.label
            },
            {
                key: 'hideTrustpilot',
                title: 'Hide Trustpilot',
                type: NICmsContentField.EFieldType.toggle
            },
            <NICmsContentField.ITextField>{
                key: 'templateId',
                type: NICmsContentField.EFieldType.text,
                title: 'Template ID',
                canShow: omit.includes('hideTrustpilot') ? canShow || (data => true) : (data: IData) => !data.hideTrustpilot,
                required: true
            },
            <NICmsContentField.ITextField>{
                key: 'businessunitId',
                type: NICmsContentField.EFieldType.text,
                title: 'Business Unit ID',
                canShow: omit.includes('hideTrustpilot') ? canShow || (data => true) : (data: IData) => !data.hideTrustpilot,
                required: true
            },
            <NICmsContentField.ITextField>{
                key: 'styleHeight',
                type: NICmsContentField.EFieldType.text,
                title: 'Style Height',
                canShow: omit.includes('hideTrustpilot') ? canShow || (data => true) : (data: IData) => !data.hideTrustpilot,
                default: '140px'
            },
            <NICmsContentField.ITextField>{
                key: 'styleWidth',
                type: NICmsContentField.EFieldType.text,
                title: 'Style Width',
                canShow: omit.includes('hideTrustpilot') ? canShow || (data => true) : (data: IData) => !data.hideTrustpilot,
                default: '100%'
            },
            <NICmsContentField.ITextField>{
                key: 'theme',
                type: NICmsContentField.EFieldType.text,
                title: 'Theme',
                canShow: omit.includes('hideTrustpilot') ? canShow || (data => true) : (data: IData) => !data.hideTrustpilot,
                default: 'light'
            },
            <NICmsContentField.ITextField>{
                key: 'stars',
                type: NICmsContentField.EFieldType.text,
                title: 'Stars',
                canShow: omit.includes('hideTrustpilot') ? canShow || (data => true) : (data: IData) => !data.hideTrustpilot,
                default: '4,5'
            },
            <NICmsContentField.ITextField>{
                key: 'reviewLanguages',
                type: NICmsContentField.EFieldType.text,
                title: 'Review Languages',
                canShow: omit.includes('hideTrustpilot') ? canShow || (data => true) : (data: IData) => !data.hideTrustpilot,
                default: 'en'
            }
        ].filter(field => !(omit as string[]).includes(field.key));
}
@Component({
    selector: 'cms-trustpilot-widget',
    templateUrl: './cms-trustpilot-widget.html',
    standalone: true,
    imports: [TrustpilotWidgetComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsTrustpilotWidgetComponent>({
    id: NCmsTrustpilotWidget.ID,
    name: 'Trustpilot Widget',
    tags: ['Trustpilot'],
    fields: NCmsTrustpilotWidget.getFields(['hideTrustpilot', 'trustpilotLabel'])
})
export class CmsTrustpilotWidgetComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsTrustpilotWidget.IData;
}
